/** API client for /api/v1/orgs/mcp/* endpoints (Org MCP API key management). */

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8001';

export interface OrgMcpKeyCreated {
  id: number;
  key: string;       // raw key — returned once only
  key_prefix: string;
  label: string | null;
  created_at: string;
}

export interface OrgMcpKeyItem {
  id: number;
  key_prefix: string;
  label: string | null;
  created_by_user_id: number | null;
  last_used_at: string | null;
  created_at: string;
}

class OrgMcpApiService {
  private getToken(): string | null {
    return localStorage.getItem('token');
  }

  private async request<T>(method: string, path: string, body?: unknown): Promise<T> {
    const token = this.getToken();
    const res = await fetch(`${API_URL}/api/v1${path}`, {
      method,
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: body !== undefined ? JSON.stringify(body) : undefined,
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({ detail: res.statusText }));
      throw new Error(err.detail || `HTTP ${res.status}`);
    }
    if (res.status === 204) return undefined as unknown as T;
    return res.json();
  }

  async generateKey(label?: string): Promise<OrgMcpKeyCreated> {
    return this.request<OrgMcpKeyCreated>('POST', '/orgs/mcp/keys', { label: label || null });
  }

  async listKeys(): Promise<OrgMcpKeyItem[]> {
    return this.request<OrgMcpKeyItem[]>('GET', '/orgs/mcp/keys');
  }

  async revokeKey(keyId: number): Promise<void> {
    return this.request<void>('DELETE', `/orgs/mcp/keys/${keyId}`);
  }
}

export const orgMcpApi = new OrgMcpApiService();
